export const codeConstants = {
    ortType: 'CND_OPR_TYPE_CD',
    incidentCrea: 'INCDNT_CREA_TYPE_CD',
    extnUser: 'EXT_APPL_INSTL_ACTN_CD',
    notiChnl: 'EXT_APPL_INSTL_NOTI_CHNL_CD',
    tcktCtgCd_open: 'TSTACTG10',
    tcktCtgCd_acknowledge: 'TSTACTG20',
    tcktCtgCd_close: 'TSTACTG30',
    tcktStatNo_open: '10001',
    tcktStatNo_acknowledge: '10002',
    tcktStatNo_close: '10003'
};



// WEBPACK FOOTER //
// ./src/app/shared/constants/src/code.constants.ts